module.exports = __webpack_public_path__ + "img/demand.6c7a250e.svg";